
// Prod
export const BASE_API_URL = "https://cwiapi.cooperwind.online";

// QA
// export const BASE_API_URL = "https://qacwiapi.cooperwind.online";

// Local
// export const BASE_API_URL = "https://nonexotic-overrigid-tereasa.ngrok-free.dev";

export const BASE_IMAGE_API_GET = "https://services.cooperwind.online/uploads/QACWIImages/";

export const BASE_DOCS_API_GET = "https://services.cooperwind.online/uploads/QACWIDocs/";
